import type { RegionDriverEarningSettingAdminDto } from '@/backend/market'
import { RegionDriverEarningSettingEntity } from '../../domain/entities/RegionDriverEarningSettingEntity'

export class RegionDriverEarningSettingModel extends RegionDriverEarningSettingEntity {
  constructor(data: RegionDriverEarningSettingAdminDto) {
    super()
    this.id = data.id
    this.regionId = data.regionId
    this.regionName = data.regionName
    this.multiDropoffDiscountPercentage = data.multiDropoffDiscountPercentage
  }
}
